<template>
    <v-dialog
        v-model="showDialog"
        scrollable
        width="45%"
        max-width="700px"
        transition="none"
        content-class="drawer"
    >
        <v-card class="elevation-0 ma-0 rounded-0" max-height="100vh">
            <v-card-title>
                <div>
                    <v-icon @click="showDialog = !showDialog">
                        mdi-chevron-right
                    </v-icon>
                    {{ getAction() }} Usuário
                </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div>
                    <v-form ref="form" class="py-5">
                        <v-row justify="center">
                            <v-col cols="12" md="12">
                                <v-text-field
                                    outlined
                                    v-model="name"
                                    :rules="nameRules"
                                    label="Nome do Usuário"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="12">
                                <v-text-field
                                    outlined
                                    v-model="email"
                                    :rules="emailRules"
                                    label="Email do Usuário"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="password"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="passwordRules"
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Senha do Usuário"
                                    :hint="getPasswordHint"
                                    outlined
                                    @click:append="showPassword = !showPassword"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="passwordConfirmation"
                                    :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="passwordConfirmationRules"
                                    :type="showPasswordConfirmation ? 'text' : 'password'"
                                    label="Confirmar a Senha"
                                    :hint="getPasswordHint"
                                    outlined
                                    @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-4">
                <v-btn
                    text
                    @click="showDialog = !showDialog"
                    width="50%"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    depressed
                    color="success"
                    @click="sendForm"
                    width="50%"
                >
                    {{ getAction() }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <response-modal
            :show-dialog="sendFormUserDialog"
            :message="sendFormUserDialogMessage"
            :type="sendFormUserDialogType"
            @close="closeModal()"
        />
    </v-dialog>
</template>

<script>
import ResponseModal from "../Modals/ResponseModal";

export default {
    name: "UserFormDrawer",

    components: {
        ResponseModal,
    },

    props: {
        user: {
            type: Object,
            default: {}
        },
        drawer: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        name: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        showDialog: false,
        showPassword: false,
        showPasswordConfirmation: false,
        sendFormUserDialog: false,
        sendFormUserDialogTitle: null,
        sendFormUserDialogMessage: null,
        sendFormUserDialogType: null,
        nameRules: [
            v => !!v || 'O nome é obrigatório',
        ],
        emailRules: [
            v => !!v || 'O email é obrigatório',
            v => !!v.match('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$') || 'O email é inválido',
        ],
        accountTypeRules: [
            v => !!v || 'O tipo da conta é obrigatório',
        ]
    }),

    computed: {
        passwordConfirmationRules() {
            if (this.password || !this.user.id) {
                return [
                    v => !!v || 'A confirmação da senha é obrigatória',
                    v => (v === this.password) || 'As senhas não coincidem'
                ];
            }
            return [v => (v === this.password) || 'As senhas não coincidem'];
        },

        passwordRules() {
            if (this.passwordConfirmation || !this.user.id) {
                return [
                    v => !!v || 'A senha é obrigatória',
                ]
            }
            return [];
        },

        getPasswordHint() {
            if (this.user.id) {
                return 'Atualizar a senha é opcional';
            }
            return '';
        },
    },

    methods: {
        setData() {
            this.name = this.user.name;
            this.email = this.user.email;
        },
        getData() {
            return {
                "name": this.name,
                "email": this.email,
                "password": this.password,
            }
        },
        clearData() {
            this.valid =
            this.name = '';
            this.email = '';
        },
        getAction() {
            if (!this.user.id) {
                return 'Cadastrar';
            }
            return 'Atualizar';
        },
        closeModal () {
            this.sendFormUserDialog = false
            this.showDialog = !this.showDialog;
            window.location.reload();
            this.$forceUpdate();
        },
        sendForm() {
            if (this.$refs.form.validate()) {
                let data = this.getData();
                if(!this.user.id){
                    axios.post('/api/user/store', data)
                        .then(res => {
                            this.getResponseMessage(res.data.success, res.data.message);
                        })
                        .catch(() => {
                            this.sendFormUserDialogMessage = 'Aconteceu algum problema...';
                            this.sendFormUserDialogType = 'error';
                        }).finally(() => {
                            this.sendFormUserDialog = true;
                        });
                }
                else{
                    axios.put("/api/user/" + this.user.id, data)
                        .then(res => {
                            this.getResponseMessage(res.data.success, res.data.message);
                        })
                        .catch(() => {
                            this.sendFormUserDialogMessage = 'Aconteceu algum problema...';
                            this.sendFormUserDialogType = 'error';
                        }).finally(() => {
                            this.sendFormUserDialog = true;
                        });
                }
            }
        },
        getResponseMessage(success, message) {
            this.sendFormUserDialogMessage = '';
            if (success) {
                this.sendFormUserDialogType = 'success';
            } else {
                this.sendFormUserDialogType = 'error';
            }
            this.sendFormUserDialogMessage = message;
        }
    },

    beforeCreated () {
        this.$on('closeResponseModal', this.closeModal);
    },

    watch: {
        drawer: function() {
            this.clearData();
            if (this.user.id) {
                this.setData();
            }
            this.showDialog = !this.showDialog;
        },
    },

}
</script>

<style scoped>
>>> .drawer {
    margin: 0;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    transition: transform 0.5s;
}

>>> .none-enter-active {
    transform: translateX(100%);
}

>>> .none-leave-active {
    transform: translateX(100%);
}

.v-dialog__content {
    justify-content: flex-end;
}
</style>
